import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import Markdown from 'react-markdown'
import { Element } from 'react-scroll'
import { CoreValueItem } from 'components'
import { ensureGetData } from 'lib/helpers'
import { AnimatePresence, motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import { Container, Columns, Column, Tabs, TabLink, TabList, Tab } from 'bloomer'

// Motion Variants
import * as motionVariants from './motion.variants'

// Style
import styles from './style.module.scss'

export const CoreValue = ({ data }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  })

  const [slideIndex, setSlide] = React.useState(0)
  const [isAnimated, setIsAnimated] = React.useState(false)

  React.useEffect(() => {
    if (!!inView) setIsAnimated(true)
  }, [inView])

  return (
    <Element name="core-value-traveloka">
      <div id="core-value-traveloka" className={clsx('nav-anchor')} ref={ref}>
        <div className={clsx('section', styles.section)}>
          <Container className={styles.container}>
            <Columns>
              <Column isSize={{ default: 12 }}>
                <motion.div
                  variants={motionVariants.container}
                  initial="hidden"
                  animate={isAnimated ? 'visible' : 'hidden'}
                  exit="exit">
                  <div className={styles.section_outer}>
                    <div className={styles.section_inner}>
                      <h2 className={clsx('section-title', styles.section_title)}>
                        {ensureGetData(data, 'title', 'Title', (res, _) =>
                          _.isString(res) ? res : res.title,
                        )}
                      </h2>

                      <Markdown className={clsx('section-copy', styles.section_body)}>
                        {ensureGetData(data, 'title', 'Content', (res, _) =>
                          _.isString(res) ? res : res.content,
                        )}
                      </Markdown>
                    </div>

                    <div className={styles.core_value_mobile_wrapper}>
                      <ul className={styles.core_value_mobile_list}>
                        {ensureGetData(data, 'content', []).map(core => (
                          <li key={core.id}>
                            <motion.div variants={motionVariants.child}>
                              <h3 className={clsx('section-subtitle', styles.core_value_title)}>
                                {core.title}
                              </h3>
                              <Markdown className={clsx('section-copy', styles.core_value_body)}>
                                {core.description}
                              </Markdown>
                            </motion.div>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className={styles.tab_wrapper}>
                      <Tabs isFullWidth="true" className={`${styles.core_nav} tab-nav core-nav`}>
                        <TabList className={styles.core_list}>
                          {ensureGetData(data, 'content', []).map((core, index) => (
                            <Tab className={styles.core_tab} key={core.id}>
                              <TabLink
                                className={slideIndex === index ? 'active' : null}
                                onClick={() => setSlide(index)}>
                                <span>{core.title}</span>
                              </TabLink>
                            </Tab>
                          ))}
                        </TabList>
                      </Tabs>

                      <ul className="tab-body">
                        <li className="tab-panel">
                          <AnimatePresence exitBeforeEnter>
                            {isAnimated && (
                              <CoreValueItem
                                data={ensureGetData(
                                  ensureGetData(data, 'content', {}),
                                  slideIndex,
                                  {},
                                )}
                                key={slideIndex}
                              />
                            )}
                          </AnimatePresence>
                        </li>
                      </ul>
                    </div>
                  </div>
                </motion.div>
              </Column>
            </Columns>
          </Container>
        </div>
      </div>
    </Element>
  )
}

CoreValue.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
}

CoreValue.defaultProps = {
  data: {},
}

export default CoreValue
